import { Button, Modal, Space } from 'antd';
import React from 'react';

import type { EdutainmentCategory } from '../../types';
import { DetailProperties } from './constants';
import styles from './index.module.scss';

type CategoryDetailProps = {
  showModal: boolean;
  closeModal: () => void;
  editingCategory: EdutainmentCategory | undefined;
};

export const CategoryDetail = ({
  showModal,
  closeModal,
  editingCategory,
}: CategoryDetailProps) => {
  return (
    <Modal
      title="查看育樂類別"
      open={showModal}
      centered
      destroyOnClose
      onCancel={closeModal}
      footer={[
        <Button key="closeButton" onClick={closeModal}>
          關閉
        </Button>,
      ]}
    >
      {editingCategory ? (
        <Space direction="vertical" size="middle">
          {Object.keys(editingCategory).map((key, index) => {
            if (key === '_id') return null;
            return (
              <Space direction="vertical" key={index} className={styles.field}>
                <h5>{DetailProperties[key]}</h5>
                <p>{editingCategory[key]}</p>
              </Space>
            );
          })}
        </Space>
      ) : (
        <div className={styles.errorContent}>
          <h4>發生錯誤，無資料內容</h4>
        </div>
      )}
    </Modal>
  );
};
